import { ThreadViewer } from "@hooks/threads/useThreadViewers";
import { Avatar, Tooltip } from "@narmi/design_system";
import styles from "./ViewerStack.module.css";

export function ViewerStack({ viewers }: { viewers: ThreadViewer[] }) {
  return (
    <div className={styles.viewerStack}>
      {viewers.map((viewer) => (
        <div className={styles.viewer} key={viewer.uuid}>
          <Tooltip text={viewer.full_name} side="top">
            <Avatar
              size="xs"
              label={viewer.full_name}
              initials={`${viewer.first_name.trim().charAt(0)}${viewer.last_name.trim().charAt(0)}`}
            />
          </Tooltip>
        </div>
      ))}
    </div>
  );
}
